var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 3,
    fill: "#007ECD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02783 15H5.92725L5.48975 13.8618H3.48682L3.07324 15H2L3.95166 9.98926H5.02148L7.02783 15ZM5.16504 13.0176L4.47461 11.1582L3.79785 13.0176H5.16504ZM7.5542 15V9.98926H9.06836L9.97754 13.4072L10.8765 9.98926H12.394V15H11.4541V11.0557L10.4595 15H9.48535L8.49414 11.0557V15H7.5542ZM13.3989 15V9.98926H17.1143V10.8369H14.4106V11.9478H16.9263V12.792H14.4106V14.1558H17.21V15H13.3989ZM17.5586 15L19.271 12.3853L17.7192 9.98926H18.9019L19.9067 11.5991L20.8911 9.98926H22.0635L20.5049 12.4229L22.2173 15H20.9971L19.8862 13.2671L18.772 15H17.5586Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.6c99180f6f32fe0b810d4e7ce4c9f9ec.svg";
export { ForwardRef as ReactComponent };